// Shared normalization for European bank codes (BIC and IBAN).
//
// Banks present these codes with separators (spaces, dashes, dots) that are purely
// cosmetic: ISO 9362 (BIC) and ISO 13616 (IBAN) both define the value itself as
// [A-Z0-9] only. Stripping everything else therefore cannot destroy a valid value,
// and it keeps a pasted "DE89 3704 0044 0532 0130 00" working.

export function sanitizeBankCode(value: string | null | undefined): string {
  return (value ?? '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
}
